import { v4 as uuidv4 } from 'uuid';
import { Product } from '@shared/models/product';
import { BookingV2Service } from '../dtos/booking-v2.dtos';

export interface BookingV2ServiceDateContext {
    from: Date | null;
    to: Date | null;
    openEnd: boolean;
}

export function createBookingV2ServiceFromProduct(
    product: Product,
    dateContext: BookingV2ServiceDateContext,
    overrides?: Partial<Pick<BookingV2Service, 'quantity' | 'unitId' | 'unitLabelKey' | 'price' | 'taxRateId' | 'vatValue'>>,
): BookingV2Service {
    const { from, to, openEnd } = dateContext;

    return {
        id: uuidv4(),
        productId: product.id,
        name: product.name,
        category: product.category?.name ?? null,
        quantity: overrides?.quantity ?? 1,
        unitId: overrides?.unitId ?? product.unit?.id ?? null,
        unitLabelKey: overrides?.unitLabelKey ?? product.unit?.translationKey ?? null,
        price: overrides?.price ?? product.price,
        taxRateId: overrides?.taxRateId ?? product.taxRate?.id ?? null,
        vatValue: overrides?.vatValue ?? product.taxRate?.value ?? 0,
        hasDynamicPrice: !!product.hasDynamicPrice,
        requiredEntities: product.priceRuleMap?.getRequirements() ?? [],
        tenantRelationCriteriaIds: product.priceRuleMap?.getTenantRelationCriteriaIds() ?? [],
        pricingRelationId: null,
        dynamicRuleName: null,
        autoName: product.name,
        dynamicPrice: null,
        serviceStart: from,
        serviceEnd: to,
        serviceEndOpen: openEnd,
    };
}
